import React from "react";
import { ReactComponent as BookshelfSvg } from "../svg/bookshelf.svg";

export default function BookshelfIcon({ size = 64, color = "#32363F", ...props }) {
  return <BookshelfSvg width={size} height={size} style={{ color }} {...props} />;
}
